import React from "react";
import { Spinner } from "react-bootstrap";

export const NO_RECORDS_FOUND = "No records found";
export const NO_DATA_FOR_PERIOD = "No data for the selected period";

export const getNoMatchContent = (isLoading = false) =>
  isLoading ? <Spinner animation="border" size="sm" /> : NO_RECORDS_FOUND;
